import { useEffect, useRef } from 'react'
import { useTranslation } from 'next-i18next'
import { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

import TestimonialItem from './TestimonialItem'
import { reviewers } from './Testimonials.const'

export default function Testimonials({ className = '' }): React.ReactElement {
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.LG })
  const isTab = useCheckBreakpoint({ gt: Breakpoint.MD })
  const swpierRef = useRef<SwiperRef | null>(null)

  useEffect(() => {
    if (swpierRef.current) {
      if (isTab || isDesktop) {
        swpierRef.current.swiper.slideTo(3)
        swpierRef.current.swiper.autoplay.stop()
      } else {
        swpierRef.current.swiper.autoplay.start()
      }
    }
  }, [isDesktop, isTab, swpierRef])

  const { t } = useTranslation('tutorOnDemand')

  return (
    <section className={`max-w-5xl z-10 w-full mx-auto space-y-4 overflow-hidden ${className}`}>
      <h2 className="text-left md:text-center text-h3 font-semibold">
        <span className="bg-clip-text text-transparent bg-gradient-tod-heading">{t('landingPage.reviews.title')}</span>
      </h2>
      <div className="relative swiper-tutor-testimonial-container">
        <Swiper
          autoplay={{ delay: 8000, disableOnInteraction: false }}
          centeredSlides
          loop
          modules={[Autoplay, Navigation, Pagination]}
          navigation={{
            nextEl: '.swiper-tutor-testimonial-container .swiper-button-next',
            prevEl: '.swiper-tutor-testimonial-container .swiper-button-prev',
          }}
          pagination={{ el: '.swiper-pagination', type: 'bullets' }}
          ref={swpierRef}
          slidesPerView={isTab || isDesktop ? 3 : 1}
          spaceBetween={isDesktop ? -230 : isTab ? -150 : 0}
          speed={500}
        >
          {reviewers.map((reviewer) => {
            return (
              <SwiperSlide className="!h-[475px] sm:!h-105 lg:!h-[372px]" key={reviewer.key}>
                {({ isActive, isNext, isPrev }) => {
                  return (isActive || isNext || isPrev) && <TestimonialItem {...reviewer} reviewerKey={reviewer.key} />
                }}
              </SwiperSlide>
            )
          })}
        </Swiper>
        <div className="swiper-pagination !-mb-3 md:!hidden" />
        <div className="swiper-button-prev testimonial-prev !text-black-light-fade !-left-4 lg:!-left-8 !hidden md:!block" />
        <div className="swiper-button-next testimonial-next !text-black-light-fade !-right-4 lg:!-right-8 !hidden md:!block" />
      </div>
    </section>
  )
}
